// extracted by mini-css-extract-plugin
module.exports = {"storyblok-category-chip-navigation__list_expanded":"StoryblokCategoryChipNavigation_storyblok-category-chip-navigation__list_expanded__rBDZX"};